import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

import i18n from '@/i18n'



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: ['effect'],
  setup(__props) {

const props = __props;



const dark = props.effect === 'dark'

const t = i18n.global.t

const dropdownLan = [
  {
    command: 'cn',
    label: t('COMMON.chinese'),
  },
  {
    command: 'en',
    label: t('COMMON.english'),
  },
]

const handleCommandLan = (command: string) => {
  if (i18n.global.locale !== command) {
    localStorage.setItem('wx_lan', command)
    location.reload()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, { onCommand: handleCommandLan }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dropdownLan, (item, index) => {
            return _createVNode(_component_el_dropdown_item, {
              key: index,
              command: item.command
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["command"])
          }), 64))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["language ws_ml16", { dark: dark }])
      }, null, 2)
    ]),
    _: 1
  }))
}
}

})